import { ColumnTypeEnum, OperationsFilterModel } from '@y42/json-schema';

export class BinFormModel {
  constructor(
    public target = '',
    public source = '',
    public parameters: BinParameterModel[] = [],
    public elseCase = 'null',
    public isNullElseCase = true,
    public outputType: ColumnTypeEnum.String = ColumnTypeEnum.String,
  ) {}
}

export class BinParameterModel {
  constructor(
    public name: string,
    public filterOp: OperationsFilterModel,
    public operations?: string, // will be deleted once we change the string
  ) {}
}
